import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-screen-2xl mx-auto px-4 md:px-10" }
const _hoisted_2 = { class: "bg-white rounded-xl px-8 md:px-16 py-12 font-light" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import BaseHeadline from "@/components/baseHeadline.vue";
import DiamondDetailColorContent from "@/components/diamonds/details/DiamondDetailColorContent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DiamondDetailColor',
  props: {
    color: {},
    colored: { type: Boolean }
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const colors = [
  { key: "j", label: "J" },
  { key: "i", label: "I" },
  { key: "h", label: "H" },
  { key: "g", label: "G" },
  { key: "f", label: "F" },
  { key: "e", label: "E" },
  { key: "d", label: "D" },
];

const initialColorLabel = computed(() => {
  const colorValue = Array.isArray(props.color) ? props.color[0] : props.color;
  if (!colorValue) return "";
  const found = colors.find((c) => c.key === colorValue.toLowerCase());
  return found ? found.label : colorValue;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DiamondDetailColorContent, {
        color: __props.color,
        colored: __props.colored
      }, {
        title: _withCtx(() => [
          _createVNode(BaseHeadline, { class: "!text-2xl mb-6 !normal-case !tracking-normal" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("components.diamonds.details.color.title")) + ": " + _toDisplayString(initialColorLabel.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["color", "colored"])
    ])
  ]))
}
}

})